/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export { IPeopleCountManager } from "./IPeopleCountManager";
export { PeopleCountManager } from "./PeopleCountManager";
export { PeopleCountResult } from "./PeopleCountResult";
